export default {"src":"/_next/static/media/StarEmptyLight.cab74c57.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};